import React from 'react';
import Link from '@atlaskit/link';
import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { CompassIcon, CompassLogo } from '@atlaskit/logo';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import {
	CompassLogo as CompassLogoTemp,
	CompassIcon as CompassIconTemp,
} from '@atlaskit/temp-nav-app-icons/compass';
import { fg } from '@atlassian/jira-feature-gating';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import { NavLogo } from '@atlassian/navigation-system';
import messages from './messages.tsx';

const styles = cssMap({
	root: {
		maxWidth: '380px',
	},
});

export type AutoCatalogEmptyStateLeftPanelProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onTry: (event: any, analyticsEvent: any) => void;
};

function AutoCatalogEmptyStateLeftPanel(props: AutoCatalogEmptyStateLeftPanelProps) {
	const { formatMessage } = useIntl();
	const { onTry } = props;

	return (
		<>
			<Stack space="space.200" alignInline="start" xcss={styles.root}>
				<NavLogo
					href="https://www.atlassian.com/software/compass/"
					label={formatMessage(messages.compass)}
					logo={fg('platform-team25-app-icon-tiles') ? CompassLogoTemp : CompassLogo}
					icon={fg('platform-team25-app-icon-tiles') ? CompassIconTemp : CompassIcon}
				/>
				<Box paddingBlock="space.200">
					<Heading size="medium" as="h3">
						{formatMessage(messages.title)}
					</Heading>
					<Box padding="space.150" />
					<Text>{formatMessage(messages.description)}</Text>
				</Box>
				<Button appearance="primary" onClick={onTry}>
					{formatMessage(messages.createYourCatalogButton)}
				</Button>
				{fg('jira_compass_cross_remove_legal_disclaimer') ? null : (
					<>
						<Text
							color="color.text.subtlest"
							size="small"
							testId="compass-cross-flow.ui.auto-catalog-empt-state-left-panel.auto-catalog-empty-state-left-panel-legal-disclaimer"
						>
							<FormattedMessage
								{...messages.legalDisclaimer}
								values={{
									boldText: <Text as="strong">{formatMessage(messages.boldText)}</Text>,
									atlassianCustomerAgreementLink: (
										<Link
											href="https://www.atlassian.com/legal/atlassian-customer-agreement#intro"
											target="_blank"
										>
											{formatMessage(messages.atlassianCustomerAgreementLink)}
										</Link>
									),
									privacyPolicyLink: (
										<Link
											href="https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers"
											target="_blank"
										>
											{formatMessage(messages.privacyPolicyLink)}
										</Link>
									),
								}}
							/>
						</Text>
						<Text color="color.text.subtlest" size="small">
							{formatMessage(messages.createYourCatalogButtonTip)}
						</Text>
					</>
				)}
			</Stack>
		</>
	);
}

export default AutoCatalogEmptyStateLeftPanel;
